export const bvnValidationStatuses = {
  validated: "VALIDATED",
  notValid: "PRESENT_BUT_NOT_VALIDATED",
  notPresent: "NOT_PRESENT",
};

export const userTypes = {
  agentUser: "AGENT_USER",
  adminUser: "ADMIN_USER",
};

export const roles = {};

export const genderOptions = [
  { label: "Male", value: "M" },
  { label: "Female", value: "F" },
];

export const idOptions = [
  { label: "National ID Card", value: "NID" },
  { label: "Driver's License", value: "DL" },
  { label: "International Passport", value: "IP" },
  { label: "Permanent Voters Card", value: "PVC" },
];

export const deviceTypeOptions = [
  {
    label: "Android",
    value: "android",
  },
];

// label ====> used in select boxes
// text =====> used in table statuses
// value ====> actual value for APO
// mapper ===> To compare to what API returns
// color ====> Aesthetics for tag
// bgColor: ====> Aesthetics for tag

export const terminalStatuses = [
  {
    label: "Disabled",
    value: 0,
    mapper: "DISABLED",
    statusText: "Disabled",
    color: "#AAA6A6",
    bgColor: "#F1F4F9",
    text: "Disabled",
  },
  {
    label: "Enabled",
    value: 1,
    mapper: "ENABLED",
    color: "#27AE60",
    bgColor: "#EAFCF2",
    text: "Enabled",
  },
  {
    label: "Unissued",
    value: 2,
    mapper: "UNISSUED",
    color: "#1966FC",
    bgColor: "#E4EAFD",
    text: "Ready",
  },
  {
    label: "Pending Update Approval",
    value: 3,
    mapper: "PENDING_UPDATED_APPROVAL_ENABLED",
    color: "#EFB008",
    bgColor: "#FCF6E6",
    text: "Pending-Update",
  },
  {
    label: "Pending Update Approval (Disabled)",
    value: 4,
    mapper: "PENDING_UPDATED_APPROVAL_DISABLED",
    color: "#AAA6A6",
    bgColor: "#F1F4F9",
    text: "Pending Update",
  },
  {
    label: "Pending Creation Approval",
    value: 5,
    mapper: "PENDING_CREATION_APPROVAL",
    color: "#EFB008",
    bgColor: "#FCF6E6",
    text: "Pending-Creation",
  },
  {
    label: "Pending Issuing Approval",
    value: 6,
    mapper: "PENDING_ISSUING_APPROVAL",
    color: "#FFFFFF",
    bgColor: " #102E88",
    text: "Pending-Issuing",
  },
  {
    label: "Pending Swap Approval",
    value: 7,
    mapper: "PENDING_SWAP_APPROVAL",
    color: "#7E6EF0",
    bgColor: "rgba(145, 130, 255, 0.15)",
    text: "Pending-Swap",
  },
  {
    label: "Creation Rejected",
    value: 8,
    mapper: "CREATION_REJECTED",
    color: "#D16415",
    bgColor: "#FCF6E6",
    text: "Creation-Rejected",
  },
  {
    label: "Force Config",
    value: 9,
    mapper: "FORCE_CONFIG",
    color: "#7E6EF0",
    bgColor: "rgba(145, 130, 255, 0.15)",
    text: "Force-Config",
  }
];

export const userStatuses = [
  {
    label: "Disabled",
    text: "Disabled",
    value: 0,
    mapper: "DISABLED",
    color: "#AAA6A6",
    bgColor: "#F1F4F9",
  },
  {
    label: "Enabled",
    text: "Active",
    value: 1,
    mapper: "ENABLED",
    color: "#27AE60",
    bgColor: "#EAFCF2",
  },
  {
    label: "Pending Creation Approval",
    text: "Pending-Creation",
    value: 2,
    mapper: "PENDING_CREATION_AUTHORIZATION",
    color: "#EFB008",
    bgColor: "#FCF6E6",
  },
  {
    label: "Pending Approval (Enabled)", //Account is currently active but admin has requested to make inactive
    text: "Pending-Approval",
    value: 3,
    mapper: "PENDING_UPDATE_APPROVAL",
    color: "#AAA6A6",
    bgColor: "#F1F4F9",
  },
  {
    label: "Pending Approval (Disabled)", ////Account is currently Disabled but admin has requested to make Enabled
    text: "Pending-Approval",
    value: 4,
    mapper: "PENDING_DISABLE_APPROVAL",
    color: "#27AE60",
    bgColor: "#EAFCF2",
  },
  {
    label: "Pending Initial Approval",
    value: 5,
    mapper: "PENDING_INITIAL_APPROVAL",
    color: "#EFB008",
    bgColor:  "#FCF6E6",
    text: "Pending-Initial",
  },
  {
    label: "initial Approval Rejected",
    value: 6,
    mapper: "INITIAL_APPROVAL_REJECTED",
    color: "#FCF6E6",
    bgColor: "#DC2C2C",
    text: "Rejected",
  },
];

export const onBoardingStatuses = [
  {
    value: 0,
    label: "Awaiting onboarding",
  },
  {
    value: 1,
    label: "Personal Information Collected",
  },
  {
    value: 2,
    label: "Error on Personal Information",
  },
  {
    value: 3,
    label: "Next of Kin Information Collected",
  },
  {
    value: 4,
    label: "Error on Next of Kin Information",
  },
  {
    value: 5,
    label: "Guarantor Details collected",
  },
  {
    value: 6,
    label: "Error on Guarantor Information",
  },
  {
    value: 7,
    label: "Files Uploaded",
  },
  {
    value: 8,
    label: "Error on Files Uploaded",
  },
  {
    value: 9,
    label: "KYC Verified",
  },
  {
    value: 10,
    label: "Unable to verify KYC",
  },
];

export const pageOptions = [
  { label: 10, value: 10 },
  { label: 20, value: 20 },
  { label: 50, value: 50 },
  { label: 100, value: 100 },
  { label: 200, value: 200 },
];

export const monthsMapper = [
  { key: "01", value: "Jan", end: "31" },
  { key: "02", value: "Feb", end: "28" },
  { key: "03", value: "Mar", end: "31" },
  { key: "04", value: "Apr", end: "30" },
  { key: "05", value: "May", end: "31" },
  { key: "06", value: "Jun", end: "30" },
  { key: "07", value: "Jul", end: "31" },
  { key: "08", value: "Aug", end: "31" },
  { key: "09", value: "Sep", end: "30" },
  { key: "10", value: "Oct", end: "31" },
  { key: "11", value: "Nov", end: "30" },
  { key: "12", value: "Dec", end: "31" },
];

export const reportinSelectOptions = [
  { value: "Funds Transfer", label: "Funds Transfer" },
  { value: "Withdrawal", label: "Withdrawal" },
  { value: "Cable Tv", label: "Cable Tv" },
  { value: "Electricity", label: "Electricity" },
  { value: "Airtime", label: "Airtime" },
];

export const carouselbreakPoints = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    partialVisibilityGutter: 11,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    partialVisibilityGutter: 30,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    partialVisibilityGutter: 120,
  },
};

export const transactionStatuses = {
  completed: "COMPLETED",
  pendingAgent: "PENDING_CREDIT_AGENT",
  pendingHold: "PENDING_HOLD",
  failed: "FAILED",
  pending: "PENDING",
};
